import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "../../components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";
import { Plus } from "lucide-react";

export const DepartmentDialog = ({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSubmit,
  editingId,
  employees,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { onOpenChange(isOpen); if (!isOpen) onClose(); }}>
      <DialogContent onCloseAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-heading">{editingId ? "Edit Department" : "Create Department"}</DialogTitle>
          <DialogDescription>{editingId ? "Update department details" : "Add a new department to your organization"}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Department Name</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="e.g., Engineering"
              className="input-field"
              required
              data-testid="dept-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Description</Label>
            <Input
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Optional description"
              className="input-field"
              data-testid="dept-desc-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Department Approver</Label>
            <Select 
              value={formData.approver_id || "none"} 
              onValueChange={(v) => setFormData({ ...formData, approver_id: v === "none" ? "" : v })}
            >
              <SelectTrigger className="input-field" data-testid="dept-approver-select">
                <SelectValue placeholder="Select approver for leave/advance requests" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">No Approver (HR Only)</SelectItem>
                {employees.map(emp => (
                  <SelectItem key={emp.id} value={emp.id}>
                    {emp.first_name} {emp.last_name} {emp.employee_code ? `(${emp.employee_code})` : ''}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-slate-500 mt-1">
              This employee will approve leave and advance requests for this department before HR final approval.
            </p>
          </div>
          <Button type="submit" className="w-full btn-primary" data-testid="create-dept-btn">
            {editingId ? "Update Department" : "Create Department"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const DesignationDialog = ({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSubmit,
  editingId,
  onClose,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { onOpenChange(isOpen); if (!isOpen) onClose(); }}>
      <DialogContent onCloseAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-heading">{editingId ? "Edit Designation" : "Create Designation"}</DialogTitle>
          <DialogDescription>{editingId ? "Update designation details" : "Add a new designation to your organization"}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Designation Name</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ name: e.target.value })}
              placeholder="e.g., Software Engineer"
              className="input-field"
              required
              data-testid="desg-name-input"
            />
          </div>
          <Button type="submit" className="w-full btn-primary" data-testid="create-desg-btn">
            {editingId ? "Update Designation" : "Create Designation"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

// Button components for opening dialogs
export const DepartmentButton = ({ onClick }) => (
  <Button variant="outline" className="rounded-full" onClick={onClick} data-testid="add-department-btn">
    <Plus className="h-4 w-4 mr-2" />
    Add Department
  </Button>
);

export const DesignationButton = ({ onClick }) => (
  <Button variant="outline" className="rounded-full" onClick={onClick} data-testid="add-designation-btn">
    <Plus className="h-4 w-4 mr-2" />
    Add Designation
  </Button>
);
